<template>
  <div>
    <div class="form-group row campaign-tags-add">
      <label for="tags" class="col-sm-2 col-form-label">Brand Tags</label>
      <div
        class="col-sm-5"
        style="text-transform:capitalize"
        autocomplete="off"
      >
        <!-- <input type="text" v-model="campaignTags"  :disabled="amsCampaignIdFetched" class="form-control" id="tags"> -->
        <multiselect
          v-model="brandTags"
          :options="brandTagsList"
          :searchable="true"
          :loading="tagSearchLoader"
          ref="multiselect"
          label="title"
          track-by="title"
          @tag="addBrandTag"
          open-direction="bottom"
          :taggable="true"
          placeholder="Brand Tags"
          class="form-control multi-dropdown col-md-12 select_filter"
          style=""
          :multiple="true"
          id="brandCampaignTags"
          :disabled="amsCampaignIdFetched"
          :closeOnSelect="false"
        >
        </multiselect>
      </div>
    </div>
    <div class="form-group row campaign-tags-add">
      <label for="tags" class="col-sm-2 col-form-label">Strategy Tags</label>
      <div
        class="col-sm-5"
        style="text-transform:capitalize"
        autocomplete="off"
      >
        <!-- <input type="text" v-model="campaignTags"  :disabled="amsCampaignIdFetched" class="form-control" id="tags"> -->
        <multiselect
          v-model="strategyTags"
          :options="strategyTagsList"
          :searchable="true"
          :loading="tagSearchLoader"
          ref="multiselect"
          label="title"
          track-by="title"
          @tag="addStrategyTag"
          open-direction="bottom"
          :taggable="true"
          placeholder="Strategy Tags"
          class="form-control multi-dropdown col-md-12 select_filter"
          style=""
          :multiple="true"
          id="strategyCampaignTags"
          :disabled="amsCampaignIdFetched"
          :closeOnSelect="false"
        >
        </multiselect>
      </div>
    </div>
    <div class="form-group row campaign-tags-add">
      <label for="tags" class="col-sm-2 col-form-label">Country Tags</label>
      <div
        class="col-sm-5"
        style="text-transform:capitalize"
        autocomplete="off"
      >
        <!-- <input type="text" v-model="campaignTags"  :disabled="amsCampaignIdFetched" class="form-control" id="tags"> -->
        <multiselect
          v-model="countryTags"
          :options="countryTagsList"
          :searchable="true"
          :loading="tagSearchLoader"
          ref="multiselect"
          label="title"
          track-by="title"
          @tag="addCountryTag"
          open-direction="bottom"
          :taggable="true"
          placeholder="Country Tags"
          class="form-control multi-dropdown col-md-12 select_filter"
          style=""
          :multiple="true"
          id="campaignTags"
          :disabled="amsCampaignIdFetched"
          :closeOnSelect="false"
        >
        </multiselect>
      </div>
    </div>
    <div class="form-group row campaign-tags-add">
      <label for="tags" class="col-sm-2 col-form-label">Segment Tags</label>
      <div
        class="col-sm-5"
        style="text-transform:capitalize"
        autocomplete="off"
      >
        <!-- <input type="text" v-model="campaignTags"  :disabled="amsCampaignIdFetched" class="form-control" id="tags"> -->
        <multiselect
          v-model="segmentTags"
          :options="segmentTagsList"
          :searchable="true"
          :loading="tagSearchLoader"
          ref="multiselect"
          label="title"
          track-by="title"
          @tag="addSegmentTag"
          open-direction="bottom"
          :taggable="true"
          placeholder="Segment Tags"
          class="form-control multi-dropdown col-md-12 select_filter"
          style=""
          :multiple="true"
          id="segmentCampaignTags"
          :disabled="amsCampaignIdFetched"
          :closeOnSelect="false"
        >
        </multiselect>
      </div>
    </div>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
export default {
  name: "PrestigeEditCampaignTag",
  props: ["tags"],
  components: {
    Multiselect,
  },
  data() {
    return {
      brandTagsList: [],
      strategyTagsList: [],
      countryTagsList: [],
      segmentTagsList: [],
      brandTags: [],
      strategyTags: [],
      segmentTags: [],
      countryTags: [],
    };
  },
  mounted() {
    this.brandTags = this.tags.brand;
    this.strategyTags = this.tags.strategy;
    this.countryTags = this.tags.country;
    this.segmentTags = this.tags.segment;
    this.getPrestigeTagList();
  },
  methods: {
    getPrestigeTagList() {
      const vm = this;
      this.$store.dispatch("campaign/getPrestigeTagList", {}).then((res) => {
        if (Object.keys(res).length) {
          this.brandTagsList = res.brand;
          this.strategyTagsList = res.strategy;
          this.countryTagsList = res.country;
          this.segmentTagsList = res.segment;
        }
      });
    },
    submit(){
        let tagList = [...this.brandTags,...this.strategyTags,...this.countryTags,...this.segmentTags];
        tagList.forEach(tag=>{
          //tag_id will be found in the case if the tag is already associated and tag.id will be used if we are associating a new tag with it
          tag.id = tag.tag_id ? tag.tag_id : tag.id
        })
        return tagList;
    },
    addBrandTag(name) {
      var pay = { title: name, id: "", type: "brand_ams" };
      this.brandTagsList.push(pay);
      this.brandTags.push(pay);
    },
    addStrategyTag(name) {
      var pay = { title: name, id: "", type: "strategy_ams" };
      this.strategyTagsList.push(pay);
      this.strategyTags.push(pay);
    },
    addCountryTag(name) {
      var pay = { title: name, id: "", type: "country_ams" };
      this.countryTagsList.push(pay);
      this.countryTags.push(pay);
    },
    addSegmentTag(name) {
      var pay = { title: name, id: "", type: "segment_ams" };
      this.segmentTagsList.push(pay);
      this.segmentTags.push(pay);
    },
  },
};
</script>
